/**
 * Build the two selector strings from linkName for attributes:
 * 'data-skip-link' and 'data-skip-show'
 * @param linkName
 * @returns {{dataLinkSelector: string, dataShowSelector: string}}
 */
var getSelectorsFromName = function getSelectorsFromName(linkName) {
  var dataLinkSelector = '[data-skip-link="' + linkName + '"]';
  var dataShowSelector = '[data-skip-show="' + linkName + '"]';
  return { dataLinkSelector: dataLinkSelector, dataShowSelector: dataShowSelector };
};
/**
 * Skip Link status
 * Can be used by tests and consumers to test whether
 * the skip link initialization was successful
 * @property {boolean} skipLinkSet: whether basic skip link functionality was init
 * @property {boolean} skipLinkShowSet: whether parent show/hide functionality was init
 */
var skipLinkStatus = {
  skipLinkSet: false,
  skipShowSet: false,
  resetStatus: function resetStatus() {
    this.skipLinkSet = false;
    this.skipShowSet = false;
  }
};
/**
 * Find dom elements by data-skip attribute
 * @param {string} linkName: the value provided via the init config,
 * identifies the elements to base the skip functionality off of
 * @returns: object with keys for link, show, and target:
 * @prop {object} link: the element with the skip link
 * @prop {object} show: the element that should show / hide (may be null)
 * @prop {object} target: the element that the anchor tag will link to
 */
var findDomElems = function findDomElems(linkName) {
  var _getSelectorsFromName = getSelectorsFromName(linkName),
      dataLinkSelector = _getSelectorsFromName.dataLinkSelector,
      dataShowSelector = _getSelectorsFromName.dataShowSelector;

  var link = document.querySelector(dataLinkSelector);
  var show = document.querySelector(dataShowSelector) || null;
  var target = link && link.hash ? document.querySelector(link.hash) : null;

  return { link: link, show: show, target: target };
};

/**
 * Show / hide when element hidden is not the link
 * as the one receiving focus (e.g the parent element)
 * @param {object} elem: the element that will be shown / hidden
 * @param {object} listener: the element that receives the focus
 */
var showHideElem = function showHideElem(elem, listener) {
  listener.addEventListener('focus', function () {
    elem.classList.remove('sr-only');
  });
  listener.addEventListener('blur', function () {
    elem.classList.add('sr-only');
  });
  // confirming focus event listeners have been added
  skipLinkStatus.skipShowSet = true;
};

/**
 * Make target element focusable
 * @param {object} target: the element defined by the anchor of the skip link
 */
var makeTargetFocusable = function makeTargetFocusable(target) {
  var domTarget = target;
  domTarget.tabIndex = -1;
  var clearTabIndex = function clearTabIndex() {
    return target.removeAttribute('tabIndex');
  };
  target.addEventListener('blur', clearTabIndex, { once: true });
};

/**
 * Initialize skip links, depending on which dom elements exist
 * @param {object} config: object containing
 * @param {array} config.links: strings used to identify the links / show
 * elements to initialize.
 */
var initSkipLinks = function initSkipLinks(config) {
  var linkSet = config.links;
  if (linkSet) {
    linkSet.forEach(function (linkName) {
      // finds the set of elements based on the strings provided
      var _findDomElems = findDomElems(linkName),
          link = _findDomElems.link,
          show = _findDomElems.show,
          target = _findDomElems.target;
      // test for required elements


      if (link && target) {
        link.addEventListener('click', function () {
          makeTargetFocusable(target);
        });
        // confirming event listener for makeTargetFocusable has been added
        skipLinkStatus.skipLinkSet = true;
        // extra functionality - only if "show" is defined
        if (show) {
          showHideElem(show, link);
        }
      }
      if (show && !target) {
        show.classList.add('skip-show--hidden');
      }
    });
  }
};
/**
 * Alternative for skip-links that navigate away from current page.  Difference is:
 * link and show are both required, target is not.
 * @param {array} skipLinkNames: array of names assigned to the 'data-skip-[link and show]'
 * attributes.
 */
var skipToNewPage = function skipToNewPage(skipLinkNames) {
  if (Array.isArray(skipLinkNames)) {
    skipLinkNames.forEach(function (linkName) {
      var _getSelectorsFromName2 = getSelectorsFromName(linkName),
          dataLinkSelector = _getSelectorsFromName2.dataLinkSelector,
          dataShowSelector = _getSelectorsFromName2.dataShowSelector;
      // only link and show are required for outside links


      var link = document.querySelector(dataLinkSelector);
      var show = document.querySelector(dataShowSelector) || null;
      if (link && show) {
        showHideElem(show, link);
      }
    });
  }
};

export { initSkipLinks as default, skipLinkStatus, skipToNewPage };
//# sourceMappingURL=index.js.map